import { bodyBgSizeIsActive } from './BodyBgStore';

export const updateBodyBgSizeIsActive = (value) => bodyBgSizeIsActive.update(oldValue => value);
